export default "__VITE_ASSET__CH5WBr$x__"